import VLIcon from "assets/img/newVLicon.svg?react";
import GPTIcon from "assets/img/gpt_symbol.svg?react";
import QwenIcon from "assets/img/qwen_logo.svg?react";
import NvidiaIcon from "assets/img/nvidia_symbol.svg?react";
import AllenAiIcon from "assets/img/allen_ai_logo.svg?react";
import DeepseekIcon from "assets/img/deepseek_logo.svg?react";
import MoondreamIcon from "assets/img/Moondream_logo.svg?react";

const iconMap: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  "newVLicon.svg": VLIcon,
  "qwen_logo.svg": QwenIcon,
  "gpt_symbol.svg": GPTIcon,
  "nvidia_symbol.svg": NvidiaIcon,
  "allen_ai_logo.svg": AllenAiIcon,
  "deepseek_logo.svg": DeepseekIcon,
  "Moondream_logo.svg": MoondreamIcon,
};

type VendorIconProps = {
  uri?: string | null;
};

export default function VendorIcon({ uri }: VendorIconProps) {
  const fallbackUri = "newVLicon.svg";
  const IconComponent = iconMap[uri || fallbackUri] || VLIcon;

  return <IconComponent />;
}
